import { Chip, Grid, Tooltip, Typography } from "@mui/material";
import React, { FC, ReactElement } from "react";
import moment from "moment";

import colorMapping from "../data/colorMapping";

import file_types from "../data/fileType";
import RequestsItemLayout from "./RequestionItemlayout";

interface I_chat {
  answer: string;
  chat_id: string;
  chat_type: string;
  completion_token: string;
  cost: string;
  model: string;
  prompt_token: string;
  question: string;
  temp: string;
  timestamp: string;
  total_token: string;
  user_email: string;
}

const RequestsItem: FC<any> = ({ item, updatedUser }: any): ReactElement => {
  return (
    <Grid
      container
      my={1}
      py={1}
      sx={{
        display: "grid",
        // gridGap: "16px",
        // gridTemplateColumns: "repeat(auto-fill,minmax(160px,1fr))",
        gridAutoFlow: "column",
        // gridAutoColumns: "minmax(160px,1fr)",
        overflowX: "auto",
        width: "calc( 100vw - 260px)",
      }}
    >
      <div
        style={{
          width: "40px",
        }}
      >
        <img src={file_types[item.chat_type]} width="20px" />
      </div>
      <RequestsItemLayout width="270" title={item.chat_id} />
      <div
        style={{
          width: "170px",
        }}
      >
        <Chip
          label={item.model}
          color={colorMapping[item.model]}
          variant="outlined"
        />
      </div>
      <RequestsItemLayout width="120" title={`$${item.cost.toFixed(7)}`} />
      <RequestsItemLayout width="90" title={item.total_token} />
      <RequestsItemLayout width="90" title={item.prompt_token} />
      <RequestsItemLayout width="110" title={item.completion_token} />
      <RequestsItemLayout width="110" title={item.temp} />
      <RequestsItemLayout
        width="200"
        title={moment(item.timestamp).format("Do MMMM YYYY")}
      />
      <RequestsItemLayout
        width="90"
        title={moment(item.timestamp).format("h:mm a")}
      />
    </Grid>
  );
};

export default RequestsItem;
